import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=39a99f60&scoped=true&"
import script from "./Dice.vue?vue&type=script&lang=js&"
export * from "./Dice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a99f60",
  null
  
)

export default component.exports